module.exports = __webpack_public_path__ + "media/images/reseller-page-5dbd4025e887c1a273333692b67fc2e8.jpg";